<template>
  <section v-if="data">
    <LayoutHeaderComponent :year="year">
      <template #prev>
        <coreButtonsArrowComponent
          :disabled="!minYear || year <= minYear"
          @click="year--"
        />
      </template>
      <template #next>
        <coreButtonsArrowComponent
          :disabled="!maxYear || year >= maxYear"
          @click="year++"
          dir="next"
        />
      </template>
    </LayoutHeaderComponent>

    <PagesExhibitionsQueryListComponent
      v-if="data?.data?.length && !pending"
      :data="data?.data"
    />

    <LayoutNoResultsComponent v-else-if="!data?.entries?.data?.length && !pending" :query="year" />

    <PagesExhibitionsQueryPrevNextPageComponent
      v-if="data?.data?.length && !pending"
      :year="year"
      :minYear="minYear"
      :maxYear="maxYear"
      @setYear="year = $event"
    />
  </section>

  <SharedErrorComponent v-else-if="data?.error" :error="data?.error" />
</template>

<script lang="ts" setup>
// FIXME temp fix
const i18nIso = 'nl-NL' //baseI18nGetDefaultIso()

const year = ref(setInitialYear())
watch(year, () => {
  updateYearQuery(year.value)
})

const route = useRoute()
let yearQuery = route?.query?.year
watch(route, () => {
  if (yearQuery || route?.query?.year) {
    year.value = Number(route?.query?.year) || setInitialYear()
  }
  yearQuery = route?.query?.year
})

const startOfYear = computed(() => dayJs(`${year.value}-01-01`).startOf('year').format('YYYY-MM-DD'))
const endOfYear = computed(() => dayJs(`${year.value}-01-01`).endOf('year').format('YYYY-MM-DD'))
const queryParams = computed(() => {
  return { dateStart: startOfYear.value, dateEnd: endOfYear.value, locale: i18nIso }
})

const { data, error, pending } = await useAsyncData(() =>
  fetchQueryPath( queryExhibitionEntriesThumbnailByDateRange(queryParams.value) ), { watch: [year]}
)

watch(pending, () => {
  document.documentElement.toggleAttribute('data-pending', pending.value)
})

// min year
const { data: lowest } = await lazyFetchQueryPath( queryExhibitionEntryExtremeDateRange(i18nIso) )
const minDateStart = computed(() => lowest?.value?.data?.[0]?.attributes?.dateStart)
const minYear = computed(() => minDateStart.value ? dayJs(minDateStart.value).year() : null)

// max year
const { data: max } = await lazyFetchQueryPath( queryExhibitionEntryExtremeDateRange(i18nIso, ['dateEnd:desc', 'dateStart:desc']) )
const maxDateEnd = computed(() => max?.value?.data?.[0]?.attributes?.dateEnd)
const maxYear = computed(() => maxDateEnd.value ? dayJs(maxDateEnd.value).year() : null)
</script>
